import { render, staticRenderFns } from "./ListingsUpdateContact.vue?vue&type=template&id=895b946c"
import script from "./ListingsUpdateContact.vue?vue&type=script&lang=js"
export * from "./ListingsUpdateContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports